import Head from "next/head";
import {useRouter} from "next/router";
import Navbar from "../../components/general/Navbar";
import HiddenMenu from "../../components/general/HiddenMenu";
import Header from "../../components/general/Header";
import Footer from "../../components/general/Footer";
import {useState, useEffect, Fragment, useRef} from "react";
import AuthServices from "../../services/Auth.services";
import {Dialog, Disclosure, Menu, Transition} from "@headlessui/react";
import {
    ChevronDownIcon,
    FunnelIcon,
} from "@heroicons/react/20/solid";
import Button from "../../components/general/Button";
import SingleProductListItem from "../../components/product/SingleProductListItem";
import BasicFilterItem from "../../components/filters/BasicFilterItem";
import SimpleActiveFilterItem from "../../components/filters/SimpleActiveFilterItem";
import BasicFilterCheckbox from "../../components/filters/BasicFilterCheckbox";
import SingleProductPulse from "../../components/product/SingleProductPulse";
import LoadingProducts from "../../components/product/LoadingProducts";
import ProductsPagination from "../../components/product/ProductsPagination";
import AddProductToQuotationOverlay from "../../components/pages/producten/partials/AddProductToQuotationOverlay";
import SimpleBadge from "../../components/general/SimpleBadge";
import AbstractService from "../../services/AbstractService";
import RouterService from "../../services/RouterService";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function Producten({
                                      navigation,
                                      loggedIn,
                                      jwtToken,
                                      productList,
                                      defaultCategory,
                                      defaultSubcategory,
                                      defaultPlantname,
                                      defaultVariant,
                                      defaultQuery,
                                      currentPage,
                                  }) {
    const router = useRouter();
    const [userInfo, setUserInfo] = useState();
    const [products, setProducts] = useState(productList);

    const [page, setPage] = useState(currentPage);
    const [pagination, setPagination] = useState({page: router.query.page});

    const inputRef = useRef(defaultQuery);

    const [pageInput, setPageInput] = useState(null);
    const pageRef = useRef(null);

    // Filters
    const [query, setZoekterm] = useState(defaultQuery);
    const [categories, setCategories] = useState();
    const [mainCategories, setMainCategories] = useState([]);
    const [subcategories, setSubcategories] = useState();
    const [plantNames, setPlantNames] = useState();

    const [colors, setColors] = useState();
    const [crowns, setCrowns] = useState();
    const [placements, setPlacements] = useState();
    const [dimensionOne, setDimensionOne] = useState([]);
    const [dimensionTwo, setDimensionTwo] = useState([]);
    const [dimensionThree, setDimensionThree] = useState([]);

    // Page stuff
    const [sortOptions, setSortOptions] = useState([]);
    const [limitOptions, setLimitOptions] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [selectedPageSize, setSelectedPageSize] = useState(null);
    const [selectedSort, setSelectedSort] = useState(null);

    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    const [overlayVariant, setOverlayVariant] = useState(null);
    const [isOverlayActive, setIsOverlayActive] = useState(false);

    /**
     *  When coming from another page we can send query params;
     *  These params should be used when requesting data, so users already have filtered products;
     *  Replacing variant is also a filter, because we only show other related products;
     */

    const [selectedVariant, setSelectedVariant] = useState(defaultVariant);

    const [selectedCheckboxes, setSelectedCheckboxes] = useState({
        dimension_one: [],
        dimension_two: [],
        dimension_three: [],
        colors: [],
        placements: [],
        crowns: [],
    });

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingFilters, setIsLoadingFilters] = useState(true);

    /**
     * Category filtering
     */
    const [categoryOne, setCategoryOne] = useState(defaultCategory ? [defaultCategory] : []);
    const [categoryTwo, setCategoryTwo] = useState(defaultSubcategory ? [defaultSubcategory] : []);
    const [categoryThree, setCategoryThree] = useState(defaultPlantname ? [defaultPlantname] : []);

    const setQuery = (string) => {
        setZoekterm(string)
        RouterService.addQueryParam(router, 'query', string);
    }

    useEffect(() => {
        const inputElement = inputRef.current;
        if (inputElement) {
            inputElement.addEventListener("keydown", handleKeyDown);
        }

        // Cleanup the event listener when component unmounts or input changes
        return () => {
            if (inputElement) {
                inputElement.removeEventListener("keydown", handleKeyDown);
            }
        };
    }, [inputRef]);

    const [searchInput, setSearchInput] = useState(defaultQuery);
    const [showOnlyAvailableAtRaalte, setOnlyAvailableAtRaalte] = useState(false);
    const [activeFilters, setActiveFilters] = useState([])
    const handlePageUp = () => {
        const currentPage = parseInt(page) + 1;
        setPage(currentPage);
        RouterService.addQueryParam(router, 'page', currentPage);
    };

    const handlePageDown = () => {
        if (page >= 1) {
            const currentPage = page - 1;
            setPage(currentPage);
            RouterService.addQueryParam(router, 'page', currentPage);
        }
    };

    useEffect(() => {
        if (fakeTrigger === 0) {
            setFakeTrigger(1);
            return;
        }

        setTrigger(trigger + 1);
    }, [
        query,
        categoryOne,
        categoryTwo,
        categoryThree,
        selectedCheckboxes,
        selectedSort,
        showOnlyAvailableAtRaalte
    ]);

    const [trigger, setTrigger] = useState(0);
    const [fakeTrigger, setFakeTrigger] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        setMobileFiltersOpen(false);
        document.body.classList.remove("filterOpened");

        const lastFilteredPage = localStorage.getItem('last_filtered');
        if(JSON.parse(lastFilteredPage)?.page == page) {
            setPage(0);
        }

        fetchData();

        if (typeof window !== "undefined") {
            const filteredData = {
                page: page,
            };

            if (categoryOne.length > 0) {
                filteredData.category = categoryOne[0].vitemId;
            }

            if (categoryTwo.length > 0) {
                filteredData.subcategory = categoryTwo[0].vitemId;
            }

            if (categoryThree.length > 0) {
                filteredData.plantname = categoryThree[0].vitemId;
            }

            localStorage.setItem("last_filtered", JSON.stringify(filteredData));
        }

        const anchorElement = document.getElementById('product-holder');
        if (anchorElement) {
            anchorElement.scrollIntoView({behavior: 'smooth'});
        }

        if (!jwtToken) {
            return;
        }

        setUserInfo(AuthServices.getUserData(jwtToken));
    }, [trigger, page, pageSize]);

    useEffect(() => {
        setIsLoadingFilters(true);
        setMobileFiltersOpen(false);
        document.body.classList.remove("filterOpened");
        setupFilters();

    }, [trigger, page, pageSize]);

    const setupFilters = async () => {

        setMainCategories({
            id: "main_categories",
            name: "Hoofdcategorieen",
            options: [],
        });

        setSubcategories({
            id: "sub_categories",
            name: "Subcategorieeen",
            options: [],
        });

        setPlantNames({
            id: "plant_names",
            name: "Plantnamen",
            options: [],
        });

        let headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");

        if (jwtToken) {
            headers.append("Authorization", "Bearer " + jwtToken);
        }

        const filters = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/products/list-filters",
            {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                    query: query,
                    page: page,
                    page_size: pageSize,
                    default_variant: defaultVariant, // when replacing variant,
                    category_one: categoryOne,
                    category_two: categoryTwo,
                    category_three: categoryThree,
                    selected_checkboxes: selectedCheckboxes,
                    selected_limit: selectedPageSize,
                    selected_sort: selectedSort,
                    show_available_at_raalte_only: showOnlyAvailableAtRaalte
                }),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
                return data.data;
            });

        setDimensionOne({
            id: "dimension_one",
            name: "Maatvoering",
            options: filters?.filters?.dimension_one ?? [],
        });

        setDimensionTwo({
            id: "dimension_two",
            name: "Potmaat",
            options: filters?.filters?.dimension_two ?? [],
        });

        setDimensionThree({
            id: "dimension_three",
            name: "Extra",
            options: filters?.filters?.dimension_three ?? [],
        });

        setColors({
            id: "colors",
            name: "Kleuren",
            options: filters?.filters?.colors ?? [],
        });

        setPlacements({
            id: "placements",
            name: "Standplaats",
            options: filters?.filters?.placements ?? [],
        });

        setCrowns({
            id: "crowns",
            name: "Kronen",
            options: filters?.filters?.crowns ?? [],
        });

        setMainCategories({
            id: "main_categories",
            name: "Hoofdcategorieen",
            options: filters?.filters?.main_categories ?? [],
        });

        setSubcategories({
            id: "sub_categories",
            name: "Subcategorieeen",
            options: filters?.filters?.sub_categories ?? [],
        });

        setPlantNames({
            id: "plant_names",
            name: "Plantnamen",
            options: filters?.filters?.plant_names ?? [],
        });

        setIsLoadingFilters(false);
    }

    const fetchData = async () => {
        let headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");

        if (jwtToken) {
            headers.append("Authorization", "Bearer " + jwtToken);
        }

        const products = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/products/list",
            {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                    query: query,
                    page: page,
                    page_size: pageSize,
                    default_variant: defaultVariant, // when replacing variant,
                    category_one: categoryOne,
                    category_two: categoryTwo,
                    category_three: categoryThree,
                    selected_checkboxes: selectedCheckboxes,
                    selected_limit: selectedPageSize,
                    selected_sort: selectedSort,
                    show_available_at_raalte_only: showOnlyAvailableAtRaalte
                }),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
                return data.data;
            });

        setProducts(products.data);
        setPagination(products.pagination);

        setSortOptions(products.sort ?? []);
        setLimitOptions(products.limit ?? []);
        setActiveFilters(products.active_filter ?? []);
        setIsLoading(false);

        // Scroll naar
        // router.asPath.split('#');
        // const anchor = router.asPath.split('#').pop().split('?')[0]; // returs ID in asPath if exists

        // if(anchor) {
        //     const productWithAnchor = products.data.find((a) => a.craft_commerce_element_uid === anchor);
        //     if(productWithAnchor) {
        //         setTimeout(function(){
        //             const element = document.getElementById(anchor);

        //             if (element) {
        //                 element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //             }
        //         }, 1);
        //     }
        // }

    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            setQuery(inputRef.current.value);
        }
    };

    const toggleOverlay = (id) => {
        setOverlayVariant(id);
        setIsOverlayActive(true);
    }

    const findCategory = () => {
        if (defaultCategory) {
            return mainCategories?.options?.find((element) => element.vitemId === defaultCategory);
        }

        return categoryOne;
    }

    const handleCategoryFilter = (option, e) => {

        if (option.parentId === null) {
            if (e?.target?.checked) {
                if (!categoryOne || !categoryOne.some((item) => item.vitemId === option.vitemId)) {
                    setCategoryOne((prevSelected) => [...(prevSelected || []), option]);
                    RouterService.addQueryParam(router, 'category', option.vitemId);
                }
            } else {
                RouterService.removeQueryParam(router, 'category');
                RouterService.removeQueryParam(router, 'subcategory');
                RouterService.removeQueryParam(router, 'plantname');
                setCategoryOne([]);
                setCategoryTwo([]);
                setCategoryThree([]);

            }
        }

        if (option.parentId) {
            const isParentInCategoryOne = categoryOne && categoryOne.some((item) => item.vitemId === option.parentId);
            if (isParentInCategoryOne) {
                if (e?.target?.checked) {
                    if (!categoryTwo || !categoryTwo.some((item) => item.vitemId === option.vitemId)) {
                        setCategoryTwo((prevSelected) => [...(prevSelected || []), option]);
                        RouterService.addQueryParam(router, 'subcategory', option.vitemId);
                    }
                } else {
                    setCategoryTwo([]);
                    setCategoryThree([]);
                    RouterService.removeQueryParam(router, 'subcategory');
                    RouterService.removeQueryParam(router, 'plantname');
                }
            }
        }

        if (option.parentId) {
            const isInSubcategories = categoryTwo && categoryTwo.some((item) => item.vitemId === option.parentId);
            if (isInSubcategories) {
                if (e?.target?.checked) {
                    if (!categoryThree || !categoryThree.some((item) => item.vitemId === option.vitemId)) {
                        setCategoryThree((prevSelected) => [...(prevSelected || []), option]);
                        RouterService.addQueryParam(router, 'plantname', option.vitemId);

                    }
                } else {
                    setCategoryThree([]);
                    RouterService.removeQueryParam(router, 'plantname');
                }
            }
        }
    };

    const handleCheckBoxfilter = (e, type, option) => {
        const value = e.target.value;
        switch (type) {
            case "DIMENSION_ONE":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.dimension_one.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            dimension_one: [
                                ...prevSelected.dimension_one,
                                {
                                    id: parseInt(value),
                                    name: option.name
                                },
                            ],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        dimension_one: prevSelected.dimension_one.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            case "DIMENSION_TWO":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.dimension_two.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            dimension_two: [
                                ...prevSelected.dimension_two,
                                {
                                    id: parseInt(value),
                                    name: option.name
                                },
                            ],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        dimension_two: prevSelected.dimension_two.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            case "DIMENSION_THREE":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.dimension_three.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            dimension_three: [
                                ...prevSelected.dimension_three,
                                {
                                    id: parseInt(value),
                                    name: option.name
                                },
                            ],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        dimension_three: prevSelected.dimension_three.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            case "COLORS":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.colors.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            colors: [...prevSelected.colors,
                                {
                                    id: parseInt(value),
                                    name: option.name
                                },
                            ],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        colors: prevSelected.colors.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            case "PLACEMENTS":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.placements.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            placements: [...prevSelected.placements, {
                                id: parseInt(value),
                                name: option.name
                            }],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        placements: prevSelected.placements.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            case "CROWNS":
                if (e.target.checked) {
                    // Add the value to the state if it's checked and not already present
                    if (
                        !selectedCheckboxes.crowns.some(
                            (item) => item.id === parseInt(value)
                        )
                    ) {
                        setSelectedCheckboxes((prevSelected) => ({
                            ...prevSelected,
                            crowns: [...prevSelected.crowns, {
                                id: parseInt(value),
                                name: option.name
                            }],
                        }));
                    }
                } else {
                    // Remove the value from the state if it's unchecked and present
                    setSelectedCheckboxes((prevSelected) => ({
                        ...prevSelected,
                        crowns: prevSelected.crowns.filter(
                            (item) => item.id !== parseInt(value)
                        ),
                    }));
                }
                break;
            default:
                console.warn("Not implemented");
        }
    };

    const mobileFilterController = () => {
        if (mobileFiltersOpen) {
            setMobileFiltersOpen(false);
            document.body.classList.remove("filterOpened");
            return;
        }
        setMobileFiltersOpen(true);
        document.body.classList.add("filterOpened");
        return;
    };

    const handleGoToPage = (value) => {
        const newPage = parseInt(value) - 1;
        setPage(newPage);
        RouterService.addQueryParam(router, 'page', newPage);
    }

    const handlePageSizeSelect = (option) => {
        setPageSize(option.name);
        setSelectedPageSize(option.value);
    }

    const handlePageSortSelect = (option) => {
        setSelectedSort(option.value);
    }

    const isOptionChecked = (option) => {
        let isChecked = false;

        categoryOne?.map((item) => {
            if (item.id === option.id)
                isChecked = true;
        });

        categoryTwo?.map((item) => {
            if (item.id === option.id)
                isChecked = true;
        });

        categoryThree?.map((item) => {
            if (item.id === option.id)
                isChecked = true;
        });

        return isChecked;
    }

    const renderActiveFilters = () => {
        let html = Object.entries(activeFilters).map(([key, value]) => {
                    if (!value) {
                        return;
                    }

                    switch (key) {
                        case 'query':
                            return <SimpleBadge
                                name={'Zoekterm'}
                                value={value}
                                removeFilterAction={() => {
                                    setQuery(null);
                                    setSearchInput('');
                                    inputRef.current = '';
                                    RouterService.removeQueryParam(router, 'query')
                                }}
                            />;
                        case 'category_one':
                            if (value.length > 0) {
                                return value.map((category, i) => (
                                    <SimpleBadge
                                        key={i}
                                        name={'Hoofdcategorie'}
                                        value={category.name}
                                        removeFilterAction={() => {
                                            handleCategoryFilter(category, null)
                                        }}
                                    />)
                                );
                            }
                        case 'category_two':
                            if (value.length > 0) {
                                return value.map((category, i) => (
                                    <SimpleBadge
                                        key={i}
                                        name={'Subcategorie'}
                                        value={category.name}
                                        removeFilterAction={() => {
                                            handleCategoryFilter(category, null)
                                        }}
                                    />)
                                );
                            }
                        case 'category_three':
                            if (value.length > 0) {
                                return value.map((category, i) => (
                                    <SimpleBadge
                                        key={i}
                                        name={'Plantnaam'}
                                        value={category.name}
                                        removeFilterAction={() => {
                                            handleCategoryFilter(category, null)
                                        }}
                                    />)
                                );

                            }
                            break;
                        case 'selected_checkboxes':
                            return Object.entries(value).map(([key, value]) => {
                                switch (key) {
                                    case 'dimension_one':
                                        if (value?.length > 0) {
                                            return value.map((d1, i) => (
                                                <SimpleBadge
                                                    key={i}
                                                    name={'Maatvoering'}
                                                    value={d1.name}
                                                    removeFilterAction={() => {
                                                        setSelectedCheckboxes((prevSelected) => ({
                                                            ...prevSelected,
                                                            dimension_one: prevSelected.dimension_one.filter(
                                                                (item) => item.id !== parseInt(d1.id)
                                                            ),
                                                        }));
                                                    }}
                                                />
                                            ));
                                        }
                                        break;
                                    case 'dimension_two':
                                        if (value?.length > 0) {
                                            return value.map((d2, i) => (
                                                <SimpleBadge
                                                    key={i}
                                                    name={'Potmaat'}
                                                    value={d2.name}
                                                    removeFilterAction={() => {
                                                        setSelectedCheckboxes((prevSelected) => ({
                                                            ...prevSelected,
                                                            dimension_two: prevSelected.dimension_two.filter(
                                                                (item) => item.id !== parseInt(d2.id)
                                                            ),
                                                        }));
                                                    }}
                                                />
                                            ));
                                        }
                                        break;
                                    case 'dimension_three':
                                        if (value?.length > 0) {
                                            return value.map((d3, i) => (
                                                <SimpleBadge
                                                    key={i}
                                                    name={'Extra'}
                                                    value={d3.name}
                                                    removeFilterAction={() => {
                                                        setSelectedCheckboxes((prevSelected) => ({
                                                            ...prevSelected,
                                                            dimension_three: prevSelected.dimension_three.filter(
                                                                (item) => item.id !== parseInt(d3.id)
                                                            ),
                                                        }));
                                                    }}
                                                />
                                            ));
                                        }
                                        break;
                                    case 'colors':
                                        if (value?.length > 0) {
                                            return value.map((d3, i) => (
                                                <SimpleBadge
                                                    key={i}
                                                    name={'Kleuren'}
                                                    value={d3.name}
                                                    removeFilterAction={() => {
                                                        setSelectedCheckboxes((prevSelected) => ({
                                                            ...prevSelected,
                                                            colors: prevSelected.colors.filter(
                                                                (item) => item.id !== parseInt(d3.id)
                                                            ),
                                                        }));
                                                    }}
                                                />
                                            ));
                                        }
                                        break;
                                    case 'placements':
                                        if (value?.length > 0) {
                                            return value.map((d3, i) => (
                                                <SimpleBadge
                                                    key={i}
                                                    name={'Standplaats'}
                                                    value={d3.name}
                                                    removeFilterAction={() => {
                                                        setSelectedCheckboxes((prevSelected) => ({
                                                            ...prevSelected,
                                                            placements: prevSelected.colors.filter(
                                                                (item) => item.id !== parseInt(d3.id)
                                                            ),
                                                        }));
                                                    }}
                                                />
                                            ));
                                        }
                                        break;
                                }
                            });
                            break;
                        default:
                            break;
                    }
                }
            )
        ;

        return html;
    }

    function handleRaalteStockToggle(e) {
        if (e.target.checked) {
            setOnlyAvailableAtRaalte(true);
        } else {
            setOnlyAvailableAtRaalte(false);
        }
    }

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>Producten overzicht | Olaf Nijenkamp</title>
                <meta name="Producten overzicht" content="Producten overzicht"/>
            </Head>

            <header>
                <Navbar items={navigation}/>
                <HiddenMenu loggedIn={loggedIn} role={userInfo?.role}/>
                <Header title={"Producten overzicht"} small={true} back={"window"}/>
            </header>

            <main className="olafGrid">
                <div className="">
                    <div>
                        <main className="mx-auto">
                            <div id={'product-holder'}
                                 className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4 border-b border-olaf-green-700 pb-6 pt-6">
                                <h3 className="text-sm lg:text-lg lg:font-semibold">
                                    Overzicht
                                </h3>
                                <div id="active-filters" className="col-span-2 gap-2 flex items-center flex-wrap">
                                    {renderActiveFilters()}
                                </div>
                                <div className="flex items-center lg:justify-end lg:col-start-4">
                                    <Menu as="div" className="relative inline-block text-left">
                                        <div>
                                            <Menu.Button
                                                className="group inline-flex justify-center text-sm font-medium text-olaf-green-500 hover:text-gray-900 bg-white px-4 py-2 rounded-md shadow-2xl ring-1 ring-black ring-opacity-5">
                                                Sorteer op
                                                <ChevronDownIcon
                                                    className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 group-hover:text-olaf-green-500"
                                                    aria-hidden="true"
                                                />
                                            </Menu.Button>
                                        </div>
                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Menu.Items
                                                className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <div className="py-1">
                                                    {sortOptions.map((option) => (
                                                        <Menu.Item key={option.name}>
                                                            {() => (
                                                                <>
                                  <span
                                      onClick={() => handlePageSortSelect(option)}
                                      className={classNames(
                                          option.active
                                              ? "font-medium text-gray-900"
                                              : "text-gray-500",
                                          option.active
                                              ? "bg-gray-100"
                                              : "hover:bg-gray-50",
                                          "block px-4 py-2 text-sm cursor-pointer"
                                      )}
                                  >
                                    {option.name}
                                  </span>
                                                                </>
                                                            )}
                                                        </Menu.Item>
                                                    ))}
                                                </div>
                                            </Menu.Items>
                                        </Transition>
                                    </Menu>
                                    <Menu
                                        as="div"
                                        className="relative inline-block text-left pl-4"
                                    >
                                        <div>
                                            <Menu.Button
                                                className="group inline-flex justify-center text-sm font-medium text-olaf-green-500 hover:text-gray-900 bg-white px-4 py-2 rounded-md shadow-2xl ring-1 ring-black ring-opacity-5">
                                                Limiteer op
                                                <ChevronDownIcon
                                                    className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 group-hover:text-olaf-green-500"
                                                    aria-hidden="true"
                                                />
                                            </Menu.Button>
                                        </div>
                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Menu.Items
                                                className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <div className="py-1">
                                                    {limitOptions.map((option) => (
                                                        <Menu.Item key={option.name}>
                                                            {() => (
                                                                <>
                                  <span
                                      className={classNames(
                                          option.active
                                              ? "font-medium text-gray-900"
                                              : "text-gray-500",
                                          option.active ? "bg-gray-100" : "",
                                          "block px-4 py-2 text-sm"
                                      )}
                                      onClick={() => handlePageSizeSelect(option)}
                                  >
                                    {option.name}
                                  </span>
                                                                </>
                                                            )}
                                                        </Menu.Item>
                                                    ))}
                                                </div>
                                            </Menu.Items>
                                        </Transition>
                                    </Menu>
                                    <button
                                        type="button"
                                        className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
                                        onClick={mobileFilterController}
                                    >
                                        <span className="sr-only">Filters</span>
                                        <FunnelIcon className="h-5 w-5" aria-hidden="true"/>
                                    </button>
                                </div>
                            </div>

                            <section
                                aria-labelledby="products-heading"
                                className="pb-24 pt-6"
                            >
                                <h2 id="products-heading" className="sr-only">
                                    Products
                                </h2>

                                <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                                    {/* Filters */}
                                    <div
                                        className={`block lg:hidden filterOverlay ${
                                            mobileFiltersOpen && "open"
                                        }`}
                                        onClick={mobileFilterController}
                                    />
                                    <div
                                        className={`block mobileFilter ${
                                            mobileFiltersOpen && "open"
                                        }`}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="1em"
                                            viewBox="0 0 384 512"
                                            onClick={mobileFilterController}
                                            className="block md:hidden ml-auto text-[30px] text-olaf-green-500 cursor-pointer"
                                        >
                                            <path
                                                d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/>
                                        </svg>
                                        <div
                                            className=" pb-8 pr-[17px]">
                                            <h3 className="sr-only">Categories</h3>

                                            <div
                                                className={
                                                    "border-b border-olaf-green-700 pb-6 hidden md:block"
                                                }
                                            >
                                                {isLoading ? (
                                                    <LoadingProducts/>
                                                ) : (
                                                    <ProductsPagination pagination={pagination}/>
                                                )}
                                                <div
                                                    className={
                                                        "flex w-full h-[35px] bg-white mt-4 border border-olaf-green-700"
                                                    }
                                                >
                                                    <input
                                                        placeholder={"Ga direct naar de betreffende pagina"}
                                                        className={"w-full h-full px-2 appearance-none"}
                                                        type={'number'}
                                                        min={1}
                                                        ref={pageRef}
                                                        value={pageInput}
                                                        onChange={(e) => setPageInput((e.target.value))}
                                                    />

                                                    <img
                                                        className={
                                                            "h-full w-[35px] bg-white p-2 cursor-pointer"
                                                        }
                                                        src="/assets/icon/chevron-right.svg"
                                                        alt="Search icon"
                                                        onClick={() => handleGoToPage(pageInput)}
                                                    />
                                                </div>
                                                <div className="w-full flex mt-2 gap-2">
                                                    <Button
                                                        handleClick={handlePageDown}
                                                        className={`${pagination?.prevPageAvailable ? "" : "opacity-50 cursor-not-allowed"
                                                        }`}
                                                        text="Vorige"
                                                        style={"secondary"}
                                                    />
                                                    <Button
                                                        handleClick={handlePageUp}
                                                        className={`${pagination?.nextPageAvailable
                                                            ? ""
                                                            : "opacity-50 cursor-not-allowed"
                                                        }`}
                                                        text="Volgende"
                                                        style={"secondary"}
                                                    />
                                                </div>
                                            </div>

                                            <div className={"border-b border-olaf-green-700 py-6"}>
                        <span className="text-xl text-olaf-green-700">
                          Zoekterm
                        </span>
                                                <div
                                                    className={
                                                        "flex w-full h-[35px] bg-white mt-4 border border-olaf-green-700"
                                                    }
                                                >
                                                    <input
                                                        placeholder={"Verfijn filter door te zoeken"}
                                                        className={"w-full h-full px-2"}
                                                        ref={inputRef}
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                    />
                                                    <img
                                                        className={
                                                            "h-full w-[35px] bg-white p-2 cursor-pointer"
                                                        }
                                                        src="/assets/icon/search.svg"
                                                        alt="Search icon"
                                                        onClick={() => setQuery(searchInput)}
                                                    />
                                                </div>
                                            </div>
                                            <BasicFilterItem
                                                name={"Categorieën"}
                                                defaultOpen={true}
                                            >
                                                <div className="space-y-4 h-full">
                                                    <div className={"space-y-2"}>
                                                        {mainCategories?.options?.filter((a) => a.id)?.map((option, optionIdx) => (
                                                            <div
                                                                key={option.value}
                                                                className="flex items-center"
                                                            >
                                                                <input
                                                                    id={`filter-${option.id}-${optionIdx}`}
                                                                    name={`${option.name}[]`}
                                                                    value={option.id}
                                                                    disabled={isLoadingFilters}
                                                                    onClick={(e) => handleCategoryFilter(option, e)}
                                                                    checked={isOptionChecked(option)}
                                                                    type="checkbox"
                                                                    className="h-4 w-4 rounded border-olaf-green-700 text-indigo-600 focus:ring-indigo-500"
                                                                />
                                                                <label
                                                                    htmlFor={`filter-${option.id}-${optionIdx}`}
                                                                    className="ml-3 text-sm text-olaf-green-700"
                                                                >
                                                                    {option.name} ({option?.count > 0 ? option?.count : 0})
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {isLoadingFilters &&
                                                            <div
                                                                className="animate-pulse flex space-x-4 relative flex-col">
                                                                <span
                                                                    className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                <span
                                                                    className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                <span
                                                                    className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </BasicFilterItem>
                                            {subcategories?.options?.length > 0 &&
                                                <BasicFilterItem
                                                    name={"Subcategorieen"}
                                                    defaultOpen={true}
                                                >
                                                    <div className="space-y-4 h-full">
                                                        <div className={"space-y-2"}>
                                                            {subcategories?.options?.filter((a) => a.id)?.map((option, optionIdx) => (
                                                                <div
                                                                    key={option.value}
                                                                    className="flex items-center"
                                                                >
                                                                    <input
                                                                        id={`filter-${option.id}-${optionIdx}`}
                                                                        name={`${option.name}[]`}
                                                                        value={option.id}
                                                                        disabled={isLoadingFilters}
                                                                        onClick={(e) => handleCategoryFilter(option, e)}
                                                                        checked={isOptionChecked(option)}
                                                                        type="checkbox"
                                                                        className="h-4 w-4 rounded border-olaf-green-700 text-indigo-600 focus:ring-indigo-500"
                                                                    />
                                                                    <label
                                                                        htmlFor={`filter-${option.id}-${optionIdx}`}
                                                                        className="ml-3 text-sm text-olaf-green-700"
                                                                    >
                                                                        {option.name} ({option?.count})
                                                                    </label>
                                                                </div>
                                                            ))}
                                                            {isLoadingFilters &&
                                                                <div
                                                                    className="animate-pulse flex space-x-4 relative flex-col">
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </BasicFilterItem>}
                                            {plantNames?.options?.length > 0 &&
                                                <BasicFilterItem
                                                    name={"Plantnamen"}
                                                    defaultOpen={true}
                                                >
                                                    <div className="space-y-4 h-full">
                                                        <div className={"space-y-2"}>
                                                            {plantNames?.options?.filter((a) => a.id)?.map((option, optionIdx) => (
                                                                <div
                                                                    key={option.value}
                                                                    className="flex items-center"
                                                                >
                                                                    <input
                                                                        id={`filter-${option.id}-${optionIdx}`}
                                                                        name={`${option.name}[]`}
                                                                        value={option.id}
                                                                        disabled={isLoadingFilters}
                                                                        onClick={(e) => handleCategoryFilter(option, e)}
                                                                        checked={isOptionChecked(option)}
                                                                        type="checkbox"
                                                                        className="h-4 w-4 rounded border-olaf-green-700 text-indigo-600 focus:ring-indigo-500"
                                                                    />
                                                                    <label
                                                                        htmlFor={`filter-${option.id}-${optionIdx}`}
                                                                        className="ml-3 text-sm text-olaf-green-700"
                                                                    >
                                                                        {option.name} ({option?.count})
                                                                    </label>
                                                                </div>
                                                            ))}
                                                            {isLoadingFilters &&
                                                                <div
                                                                    className="animate-pulse flex space-x-4 relative flex-col">
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                    <span
                                                                        className="bg-olaf-green-400 !ml-0 mb-[5px] h-[15px]"></span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </BasicFilterItem>}
                                            <BasicFilterItem
                                                name={"Maatvoering"}
                                                active={selectedCheckboxes.dimension_one}
                                            >
                                                <BasicFilterCheckbox
                                                    handleClick={handleCheckBoxfilter}
                                                    list={dimensionOne?.options}
                                                    active={selectedCheckboxes.dimension_one}
                                                    type={'DIMENSION_ONE'}
                                                    isLoading={isLoadingFilters}
                                                />
                                            </BasicFilterItem>
                                            <BasicFilterItem
                                                name={"Potmaat"}
                                                active={selectedCheckboxes.dimension_two}
                                            >
                                                <BasicFilterCheckbox
                                                    handleClick={handleCheckBoxfilter}
                                                    list={dimensionTwo?.options}
                                                    active={selectedCheckboxes.dimension_two}
                                                    type={'DIMENSION_TWO'}
                                                    isLoading={isLoadingFilters}
                                                />
                                            </BasicFilterItem>
                                            <BasicFilterItem
                                                name={"Extra"}
                                                active={selectedCheckboxes.dimension_three}
                                            >
                                                <BasicFilterCheckbox
                                                    handleClick={handleCheckBoxfilter}
                                                    list={dimensionThree?.options}
                                                    active={selectedCheckboxes.dimension_three}
                                                    type={'DIMENSION_THREE'}
                                                    isLoading={isLoadingFilters}
                                                />
                                            </BasicFilterItem>
                                            <BasicFilterItem
                                                name={"Kleuren"}
                                                active={selectedCheckboxes.colors}
                                            >
                                                <BasicFilterCheckbox
                                                    handleClick={handleCheckBoxfilter}
                                                    list={colors?.options}
                                                    active={selectedCheckboxes.colors}
                                                    type={'COLORS'}
                                                    isLoading={isLoadingFilters}
                                                />
                                            </BasicFilterItem>
                                            <BasicFilterItem
                                                name={"Standplaats"}
                                                active={selectedCheckboxes.placements}
                                            >
                                                <BasicFilterCheckbox
                                                    handleClick={handleCheckBoxfilter}
                                                    list={placements?.options}
                                                    active={selectedCheckboxes.placements}
                                                    type={'PLACEMENTS'}
                                                    isLoading={isLoadingFilters}
                                                />
                                            </BasicFilterItem>
                                            <BasicFilterItem
                                                name={"Overige filters"}
                                                active={true}
                                            >
                                                <div
                                                    key={'rs-1'}
                                                    className="flex items-center"
                                                >
                                                    <input
                                                        id={`filter-rs-1`}
                                                        name={`Raalte stock`}
                                                        value={1}
                                                        disabled={isLoadingFilters}
                                                        onClick={(e) => handleRaalteStockToggle(e)}
                                                        // checked={isOptionChecked(option)}
                                                        type="checkbox"
                                                        className="h-4 w-4 rounded border-olaf-green-700 text-indigo-600 focus:ring-indigo-500"
                                                    />
                                                    <label
                                                        htmlFor={`filter-rs-1`}
                                                        className="ml-3 text-sm text-olaf-green-700"
                                                    >
                                                        Op voorraad in Raalte
                                                    </label>
                                                </div>

                                            </BasicFilterItem>
                                        </div>
                                    </div>

                                    {/* Product grid */}
                                    <div className="lg:col-span-3">
                                        <section className={"mt-2.5 lg:mt-4 lg:col-span-9"}>
                                            <div className="grid prodCatGrid gap-1 md:gap-2 lg:gap-3 xl:gap-4">
                                                {isLoading
                                                    ? // Show pulse objects when loading
                                                    Array.from({length: 5}, (_, index) => (
                                                        <SingleProductPulse key={index}/>
                                                    ))
                                                    : // Show products looped when data is available
                                                    products.map((product) => (
                                                        <SingleProductListItem
                                                            key={product.id}
                                                            product={product}
                                                            userInfo={userInfo}
                                                            toggleOverlay={toggleOverlay}
                                                        />
                                                    ))}
                                            </div>
                                            <div
                                                className="w-full max-w-lg flex justify-center items-center gap-4 mt-8 mx-auto">
                                                <Button
                                                    handleClick={handlePageDown}
                                                    className={`${pagination?.prevPageAvailable ? "" : "opacity-50 cursor-not-allowed"
                                                    }`}
                                                    text="Vorige"
                                                    style={"secondary"}
                                                />
                                                <p className="text-sm text-olaf-green-700 !mt-2 flex-shrink-0">
                                                    {`Pagina: ${(parseInt(pagination?.page) + 1)} / ${(pagination?.totalPages + 1)}`}
                                                </p>
                                                <Button
                                                    handleClick={handlePageUp}
                                                    className={`${pagination?.nextPageAvailable
                                                        ? ""
                                                        : "opacity-50 cursor-not-allowed"
                                                    }`}
                                                    text="Volgende"
                                                    style={"secondary"}
                                                />
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </section>
                        </main>
                    </div>
                </div>
                <AddProductToQuotationOverlay
                    jwtToken={jwtToken}
                    loggedIn={loggedIn}
                    open={isOverlayActive}
                    variant={overlayVariant}
                    handleCancelAction={() => setIsOverlayActive(false)}
                    handleAcceptAction={() => setIsOverlayActive(false)}
                    userInfo={userInfo}
                    allowRedirect={false}
                />
            </main>
            <Footer/>
        </div>
    );
}

export async function getServerSideProps(context) {
    let loggedIn = !!context.req.cookies["auth"];
    let jwtToken = context.req.cookies["auth"];

    /**
     * params come from url should be added here;
     * handled in the fetchData function;
     * This method shows the loading state and makes users feel like less waiting;
     */

    const replacing_variant = context.query.variant ?? null;
    const replace_line = !!context.query.variant;

    const currentPage = context?.query?.page ?? 0;

    AuthServices.cookieCheck(jwtToken, context);
    await AuthServices.refreshToken(jwtToken, context);

    let category = context.query.category ?? null;
    let subcategory = context.query.subcategory ?? null;
    let plantname = context.query.plantname ?? null;

    if (category) {
        category = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/categories/" + category + "/filter",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                    status: data.status,
                };
            })
            .then((data) => {
                return data.data;
            });
    }

    if (subcategory) {
        subcategory = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/categories/" + subcategory + "/filter",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                    status: data.status,
                };
            })
            .then((data) => {
                return data.data;
            });
    }


    if (plantname) {
        plantname = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/categories/" + plantname + "/filter",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                    status: data.status,
                };
            })
            .then((data) => {
                return data.data;
            });
    }

    return {
        props: {
            loggedIn: loggedIn,
            jwtToken: jwtToken || null,
            productList: [],
            defaultCategory: category,
            defaultSubcategory: subcategory,
            defaultPlantname: plantname,
            defaultVariant: replacing_variant,
            replace_line: replace_line,
            defaultQuery: context.query.query ?? null,
            currentPage: currentPage
        },
    };
}
